import { render, staticRenderFns } from "./BannerImageContent.vue?vue&type=template&id=9ac2d8f6&lang=pug"
import script from "./BannerImageContent.vue?vue&type=script&lang=js"
export * from "./BannerImageContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports